export default defineAppConfig({
    loading: { color: '#923C3B' },
});
